import { APP_CONSTANTS, ROUTES } from "./utils/AppConstants";

const local = {
    baseUrl: 'http://localhost:3001/togethraPeopleApi/v1',
    imageUrl: 'http://localhost:3001/',
    visitorFormUrl: `http://localhost:3000${ROUTES.visitor.checkIn}`,
    tncUrl: `http://localhost:3000${ROUTES.tncPage}`,
    cid: '911c6649-5930-4357-9afa-b558675a7c6c',
    countryStateCity: 'dnRveHpxQk1Dc1hWVWtvUlZBVDZxWWh4SDFDQ0dVSVhJSWtybFhIUQ==',
    environment: APP_CONSTANTS.ENVIRONMENT.LOCAL,
    KEY: 'TOGETHRA_01_01_2025_HARYANA_INDIA',
    PP_ID: 'AYv6IX3fP1YnevYqY0HSBOhYmLE2JnM3FMgy2nXUEMYxQIKkyZcrrpFev7_eauzVjbqz5l0RY33cupV0'
};

const prod = {
    baseUrl: 'https://people-api.togethra.com/togethraPeopleApi/v1',
    imageUrl: 'https://people-api.togethra.com/',
    visitorFormUrl: `https://people.togethra${ROUTES.visitor.checkIn}`,
    tncUrl: `https://people.togethra${ROUTES.tncPage}`,
    cid: '911c6649-5930-4357-9afa-b558675a7c6c',
    countryStateCity: 'dnRveHpxQk1Dc1hWVWtvUlZBVDZxWWh4SDFDQ0dVSVhJSWtybFhIUQ==',
    environment: APP_CONSTANTS.ENVIRONMENT.PROD,
    KEY: 'TOGETHRA_01_01_2025_HARYANA_INDIA',
    PP_ID: 'AZphsIYfEoIw5E2Vak__fPbm3GZw3GK1YVwHjqUSwsLqt4vyAr2VGky0k47RYPnR8i3Nk0_0G5TGRG2E'
};

export const config = prod